import 'focus-visible';
import { LocalNavigation, LocalNavLink } from './local_nav';
import { Logo } from './logo';
import { NotificationMenu } from './notification_menu/notification_menu';
import { Search } from './search';
import { AccountMenu, Help, Notifications } from './utility_action_items';
import { UtilityNav } from './utility_nav';
import { Waffle } from './waffle/waffle';
import { Wrapper } from './wrapper';
import { WhatsNew } from './whats_new/whats_new';
/**
 * GlobalHeader consists of a many smaller components that act as entry-points for functionality not
 * yet supplied by us. The main purpose of this component is to provide consistent styling and rules cross-product,
 * but less so the exact shared functionality of all of it's sub-components. Although the API is composable, the actual
 * combinations are purposefully limited to create visual consistency.
 *
 */
export const GlobalHeader = {
    Search,
    Logo,
    Wrapper,
    AccountMenu,
    Notifications,
    NotificationMenu,
    Help,
    UtilityNav,
    LocalNavigation,
    LocalNavLink,
    Waffle,
    WhatsNew,
};
